<div *ngFor="let component of components">
    <ng-template appTabContentHost></ng-template>
</div>